import { css } from '@linaria/core';
import { Tab } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { ApiUI } from 'modules/Playground/Components/ApiUI';
import { VisionComponent } from 'modules/Playground/vision/VisionComponent';
import { useField } from 'formik';
import { PlaygroundContentHeader } from '../PlaygroundContentHeader/PlaygroundContentHeader';
import { useIsPlaygroundCompatibleModel } from '../TabButtons/useIsPlaygroundCompatibleModel';
import { PlaygroundConfig } from '../../types/playgroundConfig';
export const PlaygroundVisionSection: FC = () => {
  const isModelCompatible = useIsPlaygroundCompatibleModel();
  const [{
    value: model
  }] = useField<PlaygroundConfig['model']>('model');
  return <div className={PlaygroundContentContainer}>
      <div className={playgroundContentSection}>
        <div className={playgroundContentMain}>
          <Tab.Group>
            <PlaygroundContentHeader hideStreamingPlaygroundLDFF />
            <div className={playgroundContentModelSection}>
              <Tab.Panels as={Fragment}>
                {isModelCompatible ? <Tab.Panel unmount={false} className={TabPanelContainer}>
                    <VisionComponent />
                  </Tab.Panel> : null}
                <Tab.Panel unmount={false} className={TabPanelContainer}>
                  <ApiUI key={model?.id} />
                </Tab.Panel>
              </Tab.Panels>
            </div>
          </Tab.Group>
        </div>
        {/* Right Sidebar */}
      </div>
    </div>;
};
const PlaygroundContentContainer = "odules__Playground__Components__PlaygroundVisionSection__PlaygroundVisionSection_tsx-PlaygroundContentContainer-p5x1lp5";
const playgroundContentSection = "odules__Playground__Components__PlaygroundVisionSection__PlaygroundVisionSection_tsx-playgroundContentSection-pc3ylr7";
const playgroundContentMain = "odules__Playground__Components__PlaygroundVisionSection__PlaygroundVisionSection_tsx-playgroundContentMain-p1iwcdqt";
const playgroundContentModelSection = "odules__Playground__Components__PlaygroundVisionSection__PlaygroundVisionSection_tsx-playgroundContentModelSection-prvoucu";
const TabPanelContainer = "odules__Playground__Components__PlaygroundVisionSection__PlaygroundVisionSection_tsx-TabPanelContainer-tg93hkn";

require("./PlaygroundVisionSection.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PlaygroundVisionSection.tsx");